<template>
  <div class="order">
    <div class="tabstop-list">
      <div
        @click="changeTabs(index)"
        :class="item.check ? 'tab-active' : 'tab-active1'"
        class="tabstop-box"
        v-for="(item, index) in tabs"
      >
        {{ item.text }}
      </div>
    </div>
    <div class="top">
      <div class="topshaixuan">
        <div class="topshaixuantime">
          <div class="flexcenter margintb1">
            <img class="timeicon" src="/static/riqi.png" />
            <div class="textfont maincolor" @click="show = true">
              {{ date ? date : "时间筛选" }}
            </div>
          </div>
        </div>
        <div>
          <div class="flexcenter margintb1">
            <img class="timeicon" src="/static/riqi.png" />
            <div class="textfont maincolor" @click="openproject">
              {{ projectname ? projectname : "项目筛选" }}
            </div>
          </div>
        </div>
      </div>
      <van-popup
        v-model="showproject"
        position="bottom"
        :style="{ height: '30%' }"
      >
        <van-picker
          title="标题"
          show-toolbar
          :columns="columns"
          @confirm="onConfirmproject"
          @cancel="onCancelproject"
        />
      </van-popup>
      <!-- <div class="order-box">
        <div class="flexcenter margintb1">
          <img class="timeicon" src="/static/riqi.png" />
          <div class="textfont maincolor" @click="show = true">{{date ? date : '时间筛选'}}</div>
        </div>
      </div> -->
      <div class="order-box" v-if="orderList.length > 0">
        <div
          class="orderlistbox flexbetween"
          v-for="(item, index) in orderList"
          @click="toOrderDetail(index)"
        >
          <div class="flexcenter" style="width:auto">
            <img
              class="orderimgs"
              :src="item.product ? item.product.thumb : ''"
            />
            <div>
              <div class="textfont marginbottom">{{ item.product_name }}</div>
              <div class="tiptext tipcolor ">
                {{ item.user ? item.user.mobile : "" }}
              </div>
            </div>
          </div>
          <div>
            <div class="tiptext marginbottom">
              核销时间：{{ item.used_at_str }}
            </div>
            <div v-if="item.car_no" class="tiptext">
              车牌号：{{ item.car_no }}
            </div>
          </div>
        </div>
      </div>
      <div v-else class="ordernonebox">
        <img class="staffnone" src="/static/nothing.png" />
      </div>
      <div @click="getMore()" class="textmore" v-if="lengthX">查看更多</div>
      <div class="none"></div>
    </div>

    <van-calendar
      v-model="show"
      :min-date="minDate"
      type="range"
      @confirm="onConfirm"
    />
  </div>
</template>

<script>
import httper from "../../../api/http";
export default {
  data() {
    return {
      tabs: [
        {
          text: "优越车网服务",
          id: 1,
          check: true,
          source: "yy"
        },
        {
          text: "小蚂蚁服务",
          id: 2,
          check: false,
          source: "ant"
        },
        {
          text: "柠檬积分",
          id: 3,
          check: false,
          source: "lm"
        },
        {
          text: "来来车服",
          id: 3,
          check: false,
          source: "llcf"
        }
      ],

      tabId: 1, //tabId
      tabIndex: 0, //tab索引
      date: "", //日期
      startDate: "", //开始日期
      endDate: "", //结束日期
      show: false, //是否显示筛选日期
      orderList: [], //核销列表
      page: 1, //页数
      page_size: 20, //每页条数
      source: "yy", //source 默认小蚂蚁
      lengthX: false, //是否加载更多
      minDate: new Date(2010, 0, 1), //筛选日期范围 开始
      // maxDate: new Date(2050, 0, 31),//删选日期范围 结束
      showproject: false,
      projectname: "",
      projectId: 0,
      // columns: ['洗车', '保养', '机油'],
      columns: []
    };
  },
  created() {
    let that = this;
    that.request("orderList", {
      source: that.source,
      page: that.page,
      page_size: that.page_size
    });
    // console.log("this.$refs.container",this.$refs.container)
  },
  mounted() {},
  methods: {
    openproject() {
      this.showproject = true;
    },
    toOrderDetail(e) {
      let that = this;
      let orderDetail = this.orderList[e];
      this.$router.push({
        name: "verifyOrderDetail",
        params: {
          orderDetail: JSON.stringify(orderDetail)
        }
      });
    },
    onConfirmproject(e) {
      console.log("e", e.product_id);
      this.projectname = e.text;
      this.projectId = e.product_id;
      let that = this;
      let requestData = {};
      that.orderList = [];
      requestData.page = 1;
      requestData.page_size = that.page_size;
      requestData.source = that.source;
      requestData.stime = that.startDate;
      requestData.etime = that.endDate;
      if (that.projectId > 0) {
        requestData.product_id = that.projectId;
      }

      that.request("orderList", requestData);
      this.showproject = false;
    },
    onCancelproject() {
      this.showproject = false;
    },
    changeTabs(indexStr, page = 1, reset_list = true) {
      let that = this;
      let requestData = {
        source: "",
        page: page,
        page_size: that.page_size
      };
      that.page = page;
      that.projectId = 0;
      that.projectname = "";
      if (reset_list) {
        that.orderList = [];
      }
      var tab = that.tabs;
      tab.map((item, index) => (item.check = index == indexStr));
      that.tabs = tab;
      that.tabId = tab[indexStr].id;
      that.tabIndex = indexStr;
      that.source = tab[indexStr].source;
      requestData.page = that.page;
      requestData.page_size = that.page_size;
      requestData.source = that.source;
      if (that.startDate) {
        requestData.stime = that.startDate;
      }
      if (that.endDate) {
        requestData.etime = that.endDate;
      }

      if (that.projectId > 0) {
        requestData.product_id = that.projectId;
      }
      console.log("data", requestData);
      that.request("orderList", requestData);
    },
    formatDate(date) {
      console.log("date", date);
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
    onConfirm(date) {
      let that = this;
      const [start, end] = date;
      let requestData = {};
      that.show = false;
      that.date = `${this.formatDate(start)} - ${this.formatDate(end)}`;
      that.startDate = this.formatDate(start);
      that.endDate = this.formatDate(end);
      console.log("sta", that.startDate);
      that.orderList = [];
      requestData.page = that.page;
      requestData.page_size = that.page_size;
      requestData.source = that.source;
      requestData.stime = that.startDate;
      requestData.etime = that.endDate;
      if (that.projectId > 0) {
        requestData.product_id = that.projectId;
      }
      that.request("orderList", requestData);
    },
    // 调用接口
    request(type = "", requestData = {}) {
      let that = this;
      switch (type) {
        //核销列表
        case "orderList":
          httper.post(
            "service/order-list",
            requestData,
            function(res) {
              if (res.code == 0) {
                that.request("productList", {
                  source: that.source
                });
                // that.orderList = res.data
                let lengthX = res.data.length - that.page_size === 0; //判断列是否20条
                that.lengthX = lengthX;
                if (res.data.length > 0) {
                  let list = that.orderList;
                  for (let i = 0; i < res.data.length; i++) {
                    list.push(res.data[i]);
                  }
                  that.orderList = list;
                }
              } else {
                that.$toast({
                  message: res.message || "操作失败"
                });
              }
            },
            true
          );
          break;
        //服务列表
        case "productList":
          httper.post(
            "service/product-list",
            requestData,
            function(res) {
              if (res.code == 0) {
                that.columns = res.data;
              } else {
                that.$toast({
                  message: res.message || "操作失败"
                });
              }
            },
            true
          );
          break;
      }
    },
    //查看更多
    getMore() {
      let that = this;
      if (that.lengthX) {
        let page = that.page + 1;
        that.changeTabs(that.tabIndex, page, false);
      } else {
        that.$toast({
          message: "没有更多了"
        });
      }
    }
  }
};
</script>

<style scoped="scoped">
.topshaixuan {
  width: calc(100% - 20px);
  margin: 10px;
  display: flex;
  align-items: center;
}

.topshaixuantime {
  margin-right: 10px;
}

.order-box {
  width: calc(100% - 20px);
  margin: 10px;
}

.timeicon {
  width: 18px;
  height: 18px;
  margin-right: 10px;
}

.orderlistbox {
  width: 100%;
  border-radius: 8px;
  padding: 16px;
  box-sizing: border-box;
  margin-bottom: 20px;
  background-color: #ffffff;
  box-shadow: 0px 4px 5px 2px rgba(187, 187, 187, 0.3);
}

.orderimgs {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  margin-right: 15px;
}

.textmore {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #3157a3;
  /* margin-bottom: 20px; */
}

.ordernonebox {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
}

.staffnone {
  width: 200px;
  height: 200px;
}

.top {
  width: 100%;
  margin-top: 70px;
}
</style>



// WEBPACK FOOTER //
// src/pages/verify/verifyOrder.vue